import React from 'react';
import { Modal } from 'react-bootstrap';
import { Users } from 'react-feather'; 
import CreateUserForm from '../forms/UsermanagementModule/CreateUserForm';

function CreateUserModal(props) {
  return (
    <div>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="custom-modal-width"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="d-flex align-items-center">
              <Users size={24} className="mr-2 text-primary" />
              <h5 className="text-grey mb-0">Create User</h5>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreateUserForm {...props} />
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default CreateUserModal;